import React, { useRef, useEffect } from 'react'
import Typed from "typed.js";


const Home = () => {
  const el = useRef(null);

  useEffect(() => {
    const typed = new Typed(el.current, {
      strings: ["Web Developer", "Freelancer", "Content writer", "Graphic Designer"],
      // Strings to display
      // Speed settings, try diffrent values untill you get good results
      startDelay: 300,
      typeSpeed: 100,
      backSpeed: 100,
      backDelay: 100,
      smartBackspace: true,
      loop: true,
      showCursor: true
    });

    // Destropying
    return () => {
      typed.destroy();
    };
  }, []);

  return (
    <div name= "home" className='h-screen w-full bg-gradient-to-b from-gray-500 to-gray-900'>
        <div className='max-w-screen-lg mx-auto flex flex-col justify-center items-center h-full px-4 md:flex-row'>
            <div className='flex flex-col justify-center h-full'>

                <h2 className='text-4xl sm:text-7xl font-bold text-zinc-100'>Hi,I am Rishika Agarwal.</h2>
                <br />
                <h2 className='text-3xl text-gray-400 '>I'm a <span className='text-3xl text-zinc-200' ref={el}></span></h2>
                <br />
                <p className='text-1.9xl text-white py-4x tracking-wide'>I'm a Software developer with keen interest in building web applications using technologies like
                     Javascript, NodeJs, ExpressJs, Springboot and databases such as RDBMS and NoSQL. <br />
                     <p>I also have good problem solving skills in C++ and I believe in
                     giving my best with my aquired knowledge and skills.</p>
                </p>

            </div>

            {/* <div>
                <img src={require("../image.png")} alt='my-profile' className='rounded-2xl mx-auto w-2/3 md:w-full' ></img>
            </div> */}

        </div>
    </div>
  );
};

export default Home